(() => {
  const arcade = document.querySelector('[data-shyft-arcade]');

  if (!arcade) return;

  const canvas = arcade.querySelector('[data-shyft-canvas]');
  const context = canvas.getContext('2d');
  const menuItems = [...arcade.querySelectorAll('[data-shyft-menu]')];
  const bodyCards = [...arcade.querySelectorAll('[data-shyft-body-card]')];
  const caption = arcade.querySelector('[data-shyft-caption]');
  const clock = arcade.querySelector('[data-shyft-clock]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let activeIndex = 0;
  let activeBodyIndex = 0;
  let menuTimer;
  let bodyTimer;
  let width = 0;
  let height = 0;
  let stars = [];
  let shards = [];
  let tick = 0;
  let animationFrame;
  let lastDrawAt = 0;
  let accent = { r: 167, g: 72, b: 61 };
  let inView = true;

  const hexToRgb = (hex) => {
    const normalized = hex.replace('#', '');
    const value = parseInt(normalized, 16);

    return {
      r: (value >> 16) & 255,
      g: (value >> 8) & 255,
      b: value & 255
    };
  };

  const rgba = (color, alpha) => `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;

  const setActive = (index) => {
    const item = menuItems[index];

    menuItems.forEach((menuItem) => menuItem.classList.remove('is-active'));
    item.classList.add('is-active');
    caption.textContent = item.dataset.caption;
    arcade.style.setProperty('--accent', item.dataset.color);
    arcade.dataset.mode = String(index + 1);
    accent = hexToRgb(item.dataset.color);
    activeIndex = index;
  };

  const setActiveBody = (index) => {
    const card = bodyCards[index];

    bodyCards.forEach((bodyCard) => bodyCard.classList.remove('is-active'));
    card.classList.add('is-active');
    bodyCards.forEach((bodyCard) => bodyCard.style.setProperty('--card-color', bodyCard.dataset.color));
    activeBodyIndex = index;
  };

  const startMenuLoop = () => {
    window.clearInterval(menuTimer);
    if (reduceMotion) return;

    menuTimer = window.setInterval(() => {
      setActive((activeIndex + 1) % menuItems.length);
    }, 7600);
  };

  const startBodyLoop = () => {
    window.clearInterval(bodyTimer);
    if (reduceMotion) return;

    bodyTimer = window.setInterval(() => {
      setActiveBody((activeBodyIndex + 1) % bodyCards.length);
    }, 6200);
  };

  const resetParticles = () => {
    const particleFactor = width < 750 ? 18 : 14;

    stars = Array.from({ length: Math.min(90, Math.floor(width / particleFactor)) }, () => ({
      x: Math.random() * width,
      y: Math.random() * height * 0.72,
      z: 0.4 + Math.random() * 2.2,
      speed: 0.16 + Math.random() * 0.82
    }));

    shards = Array.from({ length: width < 750 ? 6 : 10 }, () => ({
      x: Math.random() * width,
      y: height * 0.2 + Math.random() * height * 0.66,
      size: 10 + Math.random() * 34,
      speed: 0.1 + Math.random() * 0.32,
      spin: Math.random() * Math.PI
    }));
  };

  const resize = () => {
    const scale = Math.min(window.devicePixelRatio || 1, 1.35);
    width = arcade.clientWidth;
    height = arcade.clientHeight;
    canvas.width = Math.max(1, Math.floor(width * scale));
    canvas.height = Math.max(1, Math.floor(height * scale));
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    context.setTransform(scale, 0, 0, scale, 0, 0);
    resetParticles();
  };

  const drawMountains = () => {
    context.lineWidth = 1;

    for (let layer = 0; layer < 3; layer += 1) {
      const baseY = height * (0.44 + layer * 0.06);
      const amplitude = 35 + layer * 22;
      const speed = tick * (0.14 + layer * 0.06);

      context.beginPath();
      context.moveTo(0, baseY);

      for (let x = -80; x <= width + 80; x += 80) {
        const pointY = baseY - Math.abs(Math.sin((x + speed) / 150)) * amplitude;
        context.lineTo(x, pointY);
      }

      context.lineTo(width, height * 0.62);
      context.lineTo(0, height * 0.62);
      context.closePath();
      context.fillStyle = layer === 0 ? rgba(accent, 0.12) : `rgba(16, 24, ${36 + layer * 14}, ${0.2 + layer * 0.08})`;
      context.fill();
      context.strokeStyle = layer === 0 ? rgba(accent, 0.46) : 'rgba(255, 255, 255, 0.12)';
      context.stroke();
    }
  };

  const drawRoad = () => {
    const horizon = height * 0.58;

    context.lineWidth = 1;
    for (let i = 0; i < 22; i += 1) {
      const y = horizon + i * i * 1.72 + ((tick * 1.15) % 42);
      const alpha = Math.max(0.08, 0.36 - i * 0.01);
      context.strokeStyle = i % 3 === 0 ? rgba(accent, alpha) : `rgba(255, 255, 255, ${alpha * 0.42})`;
      context.beginPath();
      context.moveTo(0, y);
      context.lineTo(width, y + i * 3);
      context.stroke();
    }

    for (let i = -16; i < 24; i += 1) {
      const sway = Math.sin((tick + i * 12) / 42) * 22;
      const x = width / 2 + i * 70 + sway;
      context.strokeStyle = i % 5 === 0 ? 'rgba(29, 111, 148, 0.34)' : 'rgba(255, 255, 255, 0.11)';
      context.beginPath();
      context.moveTo(width / 2, horizon);
      context.lineTo(x, height);
      context.stroke();
    }

    context.strokeStyle = rgba(accent, 0.72);
    context.lineWidth = 3;
    context.beginPath();
    context.moveTo(width * 0.48, horizon);
    context.lineTo(width * 0.2, height);
    context.moveTo(width * 0.52, horizon);
    context.lineTo(width * 0.82, height);
    context.stroke();
  };

  const drawParticles = () => {
    stars.forEach((star) => {
      star.x -= star.speed * star.z;
      star.y += Math.sin((tick + star.x) / 35) * 0.12;

      if (star.x < -8) {
        star.x = width + Math.random() * 80;
        star.y = Math.random() * height * 0.62;
        star.z = 0.4 + Math.random() * 2.2;
      }

      context.fillStyle = star.z > 1.5 ? 'rgba(255, 255, 255, 0.8)' : 'rgba(130, 194, 255, 0.58)';
      context.fillRect(Math.round(star.x), Math.round(star.y), Math.ceil(star.z * 1.6), Math.ceil(star.z * 1.6));
    });

    shards.forEach((shard) => {
      shard.x -= shard.speed;
      shard.spin += 0.01;

      if (shard.x < -60) {
        shard.x = width + 60;
        shard.y = height * 0.2 + Math.random() * height * 0.66;
      }

      context.save();
      context.translate(shard.x, shard.y);
      context.rotate(shard.spin);
      context.strokeStyle = rgba(accent, 0.22);
      context.beginPath();
      context.moveTo(0, -shard.size * 0.6);
      context.lineTo(shard.size * 0.66, shard.size * 0.52);
      context.lineTo(-shard.size * 0.48, shard.size * 0.44);
      context.closePath();
      context.stroke();
      context.restore();
    });
  };

  const drawCanvas = () => {
    if (document.hidden || !inView) return;

    const now = window.performance?.now?.() || Date.now();
    if (!reduceMotion && now - lastDrawAt < 33) {
      animationFrame = window.requestAnimationFrame(drawCanvas);
      return;
    }

    lastDrawAt = now;
    tick += 1;
    context.clearRect(0, 0, width, height);

    const gradient = context.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, 'rgba(4, 6, 12, 0.92)');
    gradient.addColorStop(0.44, `rgba(${Math.floor(accent.r * 0.06)}, ${Math.floor(accent.g * 0.08)}, ${Math.max(26, Math.floor(accent.b * 0.16))}, 0.52)`);
    gradient.addColorStop(1, 'rgba(4, 4, 7, 0.92)');
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);

    drawMountains();
    drawRoad();
    drawParticles();

    if (tick % 140 < 5) {
      context.fillStyle = rgba(accent, 0.08);
      context.fillRect(0, Math.random() * height, width, 18 + Math.random() * 42);
    }

    if (!reduceMotion) {
      animationFrame = window.requestAnimationFrame(drawCanvas);
    }
  };

  menuItems.forEach((item, index) => {
    item.style.setProperty('--item-color', item.dataset.color);
    item.addEventListener('pointerenter', () => {
      setActive(index);
      startMenuLoop();
    });
    item.addEventListener('focus', () => {
      setActive(index);
      startMenuLoop();
    });
  });

  bodyCards.forEach((card, index) => {
    card.style.setProperty('--card-color', card.dataset.color);
    card.addEventListener('pointerenter', () => {
      setActiveBody(index);
      startBodyLoop();
    });
    card.addEventListener('focus', () => {
      setActiveBody(index);
      startBodyLoop();
    });
  });

  let pointerMoveFrame;

  arcade.addEventListener('pointermove', (event) => {
    if (reduceMotion) return;

    window.cancelAnimationFrame(pointerMoveFrame);
    pointerMoveFrame = window.requestAnimationFrame(() => {
      const bounds = arcade.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 18;
      const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 12;
      arcade.style.setProperty('--scene-x', `${x}px`);
      arcade.style.setProperty('--scene-y', `${y}px`);
    });
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      window.cancelAnimationFrame(animationFrame);
      return;
    }

    lastDrawAt = 0;
    drawCanvas();
  });

  // Pause the canvas animation loop while the section is scrolled out of view so
  // it doesn't burn CPU/battery when the visitor is reading content further down.
  if ('IntersectionObserver' in window) {
    const sceneObserver = new IntersectionObserver((entries) => {
      inView = entries[0].isIntersecting;
      if (inView) {
        lastDrawAt = 0;
        drawCanvas();
      } else {
        window.cancelAnimationFrame(animationFrame);
      }
    }, { threshold: 0 });

    sceneObserver.observe(arcade);
  }

  document.addEventListener('keydown', (event) => {
    if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('[data-shyft-menu]')) return;
    event.preventDefault();

    const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
    const nextIndex = (activeIndex + direction + menuItems.length) % menuItems.length;
    setActive(nextIndex);
    menuItems[nextIndex].focus({ preventScroll: true });
    startMenuLoop();
  });

  const updateClock = () => {
    const now = new Date();
    clock.textContent = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  window.addEventListener('resize', resize);
  setActive(0);
  setActiveBody(0);
  arcade.dataset.ready = 'true';
  startMenuLoop();
  startBodyLoop();
  updateClock();
  window.setInterval(updateClock, 30000);
  resize();
  drawCanvas();

  // Reveal the homepage once the canvas has drawn its first frame and the hero
  // image is ready, so the graphics fade in together instead of popping in.
  const revealHome = () => arcade.classList.add('is-home-ready');
  const heroImage = arcade.querySelector('.shyft-arcade__blueprint-photo');

  if (heroImage && !heroImage.complete) {
    heroImage.addEventListener('load', revealHome, { once: true });
    heroImage.addEventListener('error', revealHome, { once: true });
  }

  // Reveal on the next paint after setup, and guarantee it never hangs.
  window.requestAnimationFrame(() => window.requestAnimationFrame(revealHome));
  window.setTimeout(revealHome, 1200);
})();
